module.exports = __webpack_public_path__ + "img/kd_v1.be57c15.png";